// extracted by mini-css-extract-plugin
module.exports = {"alertMarcaPropria":"marca-propria-alert_alertMarcaPropria__22Zyz"};